$(function () {
    'use strict';

    // Constants
    var PIECE_MARGIN_CONSTS = {
        containerDiv: 'pieceMargin',
        tipName: 'pieceMarginTip',
        top: { fieldName: 'PIECE_MARGIN_TOP_EF', label: 'Top' },
        bottom: { fieldName: 'PIECE_MARGIN_BOTTOM_EF', label: 'Bottom' },
        left: { fieldName: 'PIECE_MARGIN_LEFT_EF', label: 'Left' },
        right: { fieldName: 'PIECE_MARGIN_RIGHT_EF', label: 'Right' }
    };

    var PIECE_BLEED_CONSTS = {
        containerDiv: 'pieceBleed',
        tipName: 'pieceBleedTip',
        top: { fieldName: 'PIECE_BLEED_TOP_EF', label: 'Top' },
        bottom: { fieldName: 'PIECE_BLEED_BOTTOM_EF', label: 'Bottom' },
        left: { fieldName: 'PIECE_BLEED_LEFT_EF', label: 'Left' },
        right: { fieldName: 'PIECE_BLEED_RIGHT_EF', label: 'Right' }
    };

    var INSTALLER_BLEED_CONSTS = {
        containerDiv: 'installerBleed',
        tipName: 'installerBleedTip',
        top: { fieldName: 'INSTALLER_BLEED_TOP_EF', label: 'Top' },
        bottom: { fieldName: 'INSTALLER_BLEED_BOTTOM_EF', label: 'Bottom' },
        left: { fieldName: 'INSTALLER_BLEED_LEFT_EF', label: 'Left' },
        right: { fieldName: 'INSTALLER_BLEED_RIGHT_EF', label: 'Right' }
    };

    window.tbg = window.tbg || {};
    window.tbg.largeFormatBorderMarginsAndBleedsController = {
        generatePieceMargin: function () {
            if (configureglobals.clpjc.showPieceMargin !== true) {
                return;
            }

            var cquotedata = configureglobals.cquotedata;
            var edit = configureglobals.clpjc.editPieceMargin;
            var content = '';

            if (configureglobals.clpjc.showPieceMarginTip) {
                content += generateHelpTip(PIECE_MARGIN_CONSTS.tipName, TBGBOLargeFormatTip.PIECE_MARGIN);
            }

            content += '<label id="pieceMarginHeaderLabel" class="config">' + TBGBOLargeFormatTip.PIECE_MARGIN + '</label>';

            content += generateField(PIECE_MARGIN_CONSTS.top.fieldName, PIECE_MARGIN_CONSTS.top.label, cquotedata.pieceMarginTop, PIECE_MARGIN_CONSTS.containerDiv, edit);
            content += generateField(PIECE_MARGIN_CONSTS.bottom.fieldName, PIECE_MARGIN_CONSTS.bottom.label, cquotedata.pieceMarginBottom, PIECE_MARGIN_CONSTS.containerDiv, edit);
            content += generateField(PIECE_MARGIN_CONSTS.left.fieldName, PIECE_MARGIN_CONSTS.left.label, cquotedata.pieceMarginLeft, PIECE_MARGIN_CONSTS.containerDiv, edit);
            content += generateField(PIECE_MARGIN_CONSTS.right.fieldName, PIECE_MARGIN_CONSTS.right.label, cquotedata.pieceMarginRight, PIECE_MARGIN_CONSTS.containerDiv, edit);

            common.setOptionDiv(PIECE_MARGIN_CONSTS.containerDiv, content);
        },
        generatePieceBleed: function () {
            if (configureglobals.clpjc.showPieceBleed !== true) {
                return;
            }

            var cquotedata = configureglobals.cquotedata;
            var edit = configureglobals.clpjc.editPieceBleed;
            var content = '';

            if (configureglobals.clpjc.showPieceBleedTip) {
                content += generateHelpTip(PIECE_BLEED_CONSTS.tipName, TBGBOLargeFormatTip.PIECE_BLEED);
            }

            content += '<label id="pieceBleedHeaderLabel" class="config">' + TBGBOLargeFormatTip.PIECE_BLEED + '</label>';

            content += generateField(PIECE_BLEED_CONSTS.top.fieldName, PIECE_BLEED_CONSTS.top.label, cquotedata.pieceBleedTop, PIECE_BLEED_CONSTS.containerDiv, edit);
            content += generateField(PIECE_BLEED_CONSTS.bottom.fieldName, PIECE_BLEED_CONSTS.bottom.label, cquotedata.pieceBleedBottom, PIECE_BLEED_CONSTS.containerDiv, edit);
            content += generateField(PIECE_BLEED_CONSTS.left.fieldName, PIECE_BLEED_CONSTS.left.label, cquotedata.pieceBleedLeft, PIECE_BLEED_CONSTS.containerDiv, edit);
            content += generateField(PIECE_BLEED_CONSTS.right.fieldName, PIECE_BLEED_CONSTS.right.label, cquotedata.pieceBleedRight, PIECE_BLEED_CONSTS.containerDiv, edit);

            common.setOptionDiv(PIECE_BLEED_CONSTS.containerDiv, content);
        },
        generateInstallerBleed: function () {
            if (configureglobals.clpjc.showInstallerBleed !== true) {
                return;
            }

            var cquotedata = configureglobals.cquotedata;
            var edit = configureglobals.clpjc.editInstallerBleed;
            var content = '';

            if (configureglobals.clpjc.showInstallerBleedTip) {
                content += generateHelpTip(INSTALLER_BLEED_CONSTS.tipName, TBGBOLargeFormatTip.INSTALLER_BLEED);
            }

            content += '<label id="installerBleedHeaderLabel" class="config">' + TBGBOLargeFormatTip.INSTALLER_BLEED + '</label>';

            content += generateField(INSTALLER_BLEED_CONSTS.top.fieldName, INSTALLER_BLEED_CONSTS.top.label, cquotedata.installerBleedTop, INSTALLER_BLEED_CONSTS.containerDiv, edit);
            content += generateField(INSTALLER_BLEED_CONSTS.bottom.fieldName, INSTALLER_BLEED_CONSTS.bottom.label, cquotedata.installerBleedBottom, INSTALLER_BLEED_CONSTS.containerDiv, edit);
            content += generateField(INSTALLER_BLEED_CONSTS.left.fieldName, INSTALLER_BLEED_CONSTS.left.label, cquotedata.installerBleedLeft, INSTALLER_BLEED_CONSTS.containerDiv, edit);
            content += generateField(INSTALLER_BLEED_CONSTS.right.fieldName, INSTALLER_BLEED_CONSTS.right.label, cquotedata.installerBleedRight, INSTALLER_BLEED_CONSTS.containerDiv, edit);

            common.setOptionDiv(INSTALLER_BLEED_CONSTS.containerDiv, content);
        },
        decorateCometRequestForGetQuote: function (cometRequest) {
            if (configureglobals.clpjc.editPieceMargin === true) {
                cometRequest.addFormField(PIECE_MARGIN_CONSTS.top.fieldName, false, document);
                cometRequest.addFormField(PIECE_MARGIN_CONSTS.bottom.fieldName, false, document);
                cometRequest.addFormField(PIECE_MARGIN_CONSTS.left.fieldName, false, document);
                cometRequest.addFormField(PIECE_MARGIN_CONSTS.right.fieldName, false, document);
            }

            if (configureglobals.clpjc.editPieceBleed === true) {
                cometRequest.addFormField(PIECE_BLEED_CONSTS.top.fieldName, false, document);
                cometRequest.addFormField(PIECE_BLEED_CONSTS.bottom.fieldName, false, document);
                cometRequest.addFormField(PIECE_BLEED_CONSTS.left.fieldName, false, document);
                cometRequest.addFormField(PIECE_BLEED_CONSTS.right.fieldName, false, document);
            }

            if (configureglobals.clpjc.editInstallerBleed === true) {
                cometRequest.addFormField(INSTALLER_BLEED_CONSTS.top.fieldName, false, document);
                cometRequest.addFormField(INSTALLER_BLEED_CONSTS.bottom.fieldName, false, document);
                cometRequest.addFormField(INSTALLER_BLEED_CONSTS.left.fieldName, false, document);
                cometRequest.addFormField(INSTALLER_BLEED_CONSTS.right.fieldName, false, document);
            }
        }
    };

    function generateHelpTip (fieldName, globalName) {
        return tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'' + fieldName + '\',\'' + globalName + '\')', {
            id: fieldName,
            cssClass: 'quoteHelp',
            tabindex: '-1',
            title: 'More Information'
        });
    }

    function generateField (fieldName, label, value, containerDiv, edit) {
        var fieldHasError = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

        var content = '';

        content += '<label class="config">' + label + '</label>';

        if (edit) {
            content += forms.ef(fieldName, value, {
                size: 10,
                cssClass: 'configField' + (fieldHasError ? ' error' : ''),
                onfocus: 'common.efFocus(\'' + fieldName + '\',\'' + containerDiv + '\', \'' + fieldName + '_FOCUS\')',
                onblur: 'common.efBlur(\'' + fieldName + '\',\'' + containerDiv + '\', \'' + fieldName + '_FOCUS\')'
            });
        } else {
            content += tags.div(value, { cssClass: 'noEdit' });
        }

        content += '<span id="' + fieldName + '_FOCUS" class="changeFocusButton"><!-- dynamic --></span>';

        if (fieldHasError) {
            content += '<div id="' + fieldName + '_FIELD_ERROR_MESSAGE">' + common.validation.generateJobQuoteFieldMessagesFor(fieldName) + '</div>';
        }

        return content;
    }
});
